import React from 'react'
import {
    DropDown,
    IconArrowRight, IconCreditCard,
    IconDuplicate, IconEdit,
    IconEmail,
    IconPenalize, IconProgram, IconRepeat, IconWspAlert,
    ListItem
} from '@Knowledge-OTP/znk-ui-components'
import {useDispatch} from 'react-redux'
import useTranslation from '../../../../../i18n/useTranslation'

const List = (props) => {
    const {translate} = useTranslation()
    const dispatch = useDispatch()
    const {lesson: dataLesson} = props
    const makeup = dataLesson?.isMakeUp || false
    const isGroup = dataLesson.__typename === 'GroupLesson'
    return (
        <>
            <ListItem
                className='p-2'
                onClick={() => {
                    dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'lesson.sendEmailReminder',
                        data: {
                            isOpen: true,
                            dataLesson: dataLesson,
                            studentsId: [],
                            educatorId: null
                        }
                    })
                }}
                Left={
                    <div className='d-flex flex-row'>
                        <IconEmail color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
              {translate('modal.infolesson.sendreminder')}
            </span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />
            <ListItem
                showTopLine
                className='p-2'
                onClick={() => {
                    dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'lesson.wspAlert',
                        data: {
                            isOpen: true,
                            dataLesson: dataLesson,
                            studentsId: [],
                            educatorId: null
                        }
                    })
                }}
                Left={
                    <div className='d-flex flex-row'>
                        <IconWspAlert color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
              {translate('modal.infolesson.sendwspalert')}
            </span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />

            
            <ListItem
                showTopLine
                className='p-2'
                Left={
                    <div className='d-flex flex-row'>
                        <IconProgram color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
                      {translate('modal.infolesson.scheduledoptions')}
                    </span>
                    </div>
                }
                Right={
                    <div className='znk-table-dropdown dropdown-menu-width-content pr-0'>
                        <DropDown
                            direction='down'
                            fixedWidth
                            hoverEnabled={false}
                            options={[
                                {
                                    component:
                                        <span onClick={() => {
                                            dispatch({
                                                type: 'SET_DATA_MODAL_FORM_LIST',
                                                payload: 'lesson.rescheduledLesson',
                                                data: {
                                                    isOpen: true,
                                                    dataLesson: dataLesson
                                                }
                                            })
                                        }}
                                        >{translate('modal.infolesson.rescheduling')}
                            </span>
                                }
                            ].concat(!isGroup ? [{
                                component:
                                    <span
                                        onClick={() => {
                                            dispatch({
                                                type: 'SET_DATA_MODAL_FORM_LIST',
                                                payload: 'plan.setPendingLesson',
                                                data: {
                                                    isOpen: true,
                                                    lessonId: dataLesson?.id || ''
                                                }
                                            })
                                        }}>{translate('modal.infolesson.leavepending')}</span>
                            }] : [])}
                        >
                            <IconArrowRight/>
                        </DropDown>
                    </div>
                }
            />
            <ListItem
                onClick={() => {
                    dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'plan.duplicateLessonModal',
                        data: {
                            isOpen: true,
                            dataLesson: dataLesson
                        }
                    })
                }}
                showTopLine
                className='p-2'
                Left={
                    <div className='d-flex flex-row'>
                        <IconDuplicate color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
              {translate('modal.infolesson.duplicatelesson')}
            </span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />












            <ListItem
                onClick={() => {
                    if (!makeup) {
                        dispatch({
                            type: 'SET_DATA_MODAL_FORM_LIST',
                            payload: 'plan.makeUpLesson',
                            data: {
                                isOpen: true,
                                dataLesson: dataLesson
                            }
                        })
                    }
                }}
                showTopLine
                className='p-2'
                Left={
                    <div className='d-flex flex-row'>
                        <IconRepeat color={makeup ? '#D6DAE3' : '#696CFF'}
                                    className='align-self-center mr-2'/>
                        <span
                            className={`align-self-center ${makeup ? 'text-disabled' : 'text-primary'}`}>
              {translate('modal.infolesson.makeuplesson')}
            </span>
                    </div>
                }
                Right={
                    makeup
                        ? <IconArrowRight color='#D6DAE3'/>
                        : <IconArrowRight/>
                }
            />
            <ListItem
                showTopLine
                className='p-2'
                onClick={
                    () => {
                        dispatch({
                            type: 'SET_DATA_MODAL_FORM_LIST',
                            payload: 'plan.penalizeLesson',
                            data: {
                                isOpen: true,
                                dataLesson: dataLesson
                            }
                        })
                    }
                }
                Left={
                    <div className='d-flex flex-row'>
                        <IconPenalize color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
              {translate('modal.infolesson.penalizelesson')}
            </span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />
            <ListItem
                showTopLine
                className='p-2'
                onClick={
                    () => {
                        dispatch({
                            type: 'SET_DATA_MODAL_FORM_LIST',
                            payload: 'lesson.editLessonModal',
                            data: {
                                isOpen: true,
                                dataLesson: dataLesson,
                                editPending: false
                            }
                        })
                    }
                }
                Left={
                    <div className='d-flex flex-row'>
                        <IconEdit color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
              {translate('modal.infolesson.editlesson')}
            </span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />





            <ListItem
                showTopLine
                onClick={
                    () => {
                        dispatch({
                            type: 'SET_DATA_MODAL_FORM_LIST',
                            payload: 'plan.editPaymentLesson',
                            data: {
                                isOpen: true,
                                dataLesson: dataLesson
                            }
                        })
                    }
                }
                className='p-2'
                Left={
                    <div className='d-flex flex-row'>
                        <IconCreditCard color='#696CFF' className='align-self-center mr-2'/>
                        <span className='align-self-center text-primary'>
              {translate('modal.infolesson.editpayment')}
            </span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />
            <ListItem
                showTopLine
                onClick={() => {
                    dispatch({
                        type: 'SET_DATA_MODAL_FORM_LIST',
                        payload: 'plan.cancelLesson',
                        data: {
                            isOpen: true,
                            lessonId: dataLesson?.id || '',
                            isOrientation: false
                        }
                    })
                }}
                className='p-2'
                Left={
                    <div className='d-flex flex-row'>
                        <span className='h5 text-gray'>{translate('modal.infolesson.youneedremove')}</span>
                    </div>
                }
                Right={<IconArrowRight/>}
            />
        </>
    )
}

export default List
